module.exports = __webpack_public_path__ + "img/thumbnail_CaliforniaSeaLion_f_normal.6aae0f84.png";